import type { ChangeEvent, CSSProperties, ReactNode } from 'react';

interface InputProps {
  label?: ReactNode;
  placeholder?: string;
  value?: string;
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void;
  error?: ReactNode;
  type?: string;
  autoFocus?: boolean;
  style?: CSSProperties;
}

export function Input({ label, placeholder, value, onChange, error, type = 'text', autoFocus, style }: InputProps) {
  return (
    <label style={{ display: 'flex', flexDirection: 'column', gap: 6, fontFamily: 'var(--font-vi)', ...style }}>
      {label && <span style={{ fontSize: 13, fontWeight: 600, color: 'var(--ink)' }}>{label}</span>}
      <input
        type={type}
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        autoFocus={autoFocus}
        style={{
          height: 'var(--touch-min)',
          padding: '0 14px',
          fontSize: 16,
          fontFamily: 'var(--font-vi)',
          borderRadius: 'var(--radius-control)',
          border: `1px solid ${error ? 'var(--error)' : 'var(--border-default)'}`,
          outline: 'none',
          color: 'var(--ink)',
          background: 'var(--surface-page)',
        }}
      />
      {error && <span style={{ fontSize: 12, color: 'var(--error)' }}>{error}</span>}
    </label>
  );
}
